<template>
  <div class="grided-template">
    <MenuComponent></MenuComponent>
    <div>
      <default-header :visible="headerVisibility"></default-header>
      <DashboardGestao></DashboardGestao>
    </div>
  </div>
</template>

<script>
import MenuComponent from "@/components/src/MenuComponent";
import DefaultHeader from "@/components/src/DefaultHeaderComponent";
import DashboardGestao from "@/components/src/DashboardGestao";

export default {
  name: "DashboardGestaoView",
  components: {
    MenuComponent,
    DefaultHeader,
    DashboardGestao,
  },
  data() {
    return {
      headerVisibility: false,
    };
  },
  mounted() {
    document.title = "Dashboard de Gestão - Cardápio Inteligente";
  },
};
</script>

<style scoped lang="less">
@import (reference) url("../../assets/variables.less");
</style>